var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-batch-add-lab-order',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"pt-batch-add-lab-order__withData",attrs:{"billDetail":_vm.data}})}
var staticRenderFns = []

export { render, staticRenderFns }